function readHilux() {
 document.getElementById("shopify-section-template--15915107254359__text_and_image_wbXKLd").style.display = "block";
 document.getElementById("shopify-section-template--15915107254359__rich_text_HVWjF8").style.display = "block";
 document.getElementById("shopify-section-template--15915107254359__advanced_content_C4nNi9").style.display = "block";
 document.getElementById("shopify-section-template--15915107254359__rich_text_hpEBEY").style.display = "block";
 document.getElementById("shopify-section-template--15915107254359__rich_text_9xUhez").style.display = "block";
 document.getElementById("shopify-section-template--15915107254359__text_with_icons_QWV6TH").style.display = "block";
    $(".readless").show();
  $(".readmore").hide();
}

function readFord() {
 document.getElementById("shopify-section-template--15907375317079__text_and_image_wbXKLd").style.display = "block";
 document.getElementById("shopify-section-template--15907375317079__rich_text_HVWjF8").style.display = "block";
 document.getElementById("shopify-section-template--15907375317079__text_with_icons_QWV6TH").style.display = "block";
 document.getElementById("shopify-section-template--15907375317079__advanced_content_C4nNi9").style.display = "block";
 document.getElementById("shopify-section-template--15907375317079__rich_text_hpEBEY").style.display = "block";
 document.getElementById("shopify-section-template--15907375317079__rich_text_9xUhez").style.display = "block";
  $(".readlessFord").show();
  $(".readmore").hide();
}

function readFordeverest() {
 document.getElementById("shopify-section-template--16199477559383__text_and_image_wbXKLd").style.display = "block";
 document.getElementById("shopify-section-template--16199477559383__rich_text_HVWjF8").style.display = "block";
 document.getElementById("shopify-section-template--16199477559383__text_with_icons_QWV6TH").style.display = "block";
 document.getElementById("shopify-section-template--16199477559383__advanced_content_C4nNi9").style.display = "block";
 document.getElementById("shopify-section-template--16199477559383__rich_text_hpEBEY").style.display = "block";
 document.getElementById("shopify-section-template--16199477559383__rich_text_9xUhez").style.display = "block";
  $(".readlessFordeverest").show();
  $(".readmore").hide();
}

function readAmarok() {
 document.getElementById("shopify-section-template--16199537360983__text_and_image_wbXKLd").style.display = "block";
 document.getElementById("shopify-section-template--16199537360983__rich_text_HVWjF8").style.display = "block";
 document.getElementById("shopify-section-template--16199537360983__text_with_icons_QWV6TH").style.display = "block";
 document.getElementById("shopify-section-template--16199537360983__advanced_content_C4nNi9").style.display = "block";
 document.getElementById("shopify-section-template--16199537360983__rich_text_hpEBEY").style.display = "block";
 document.getElementById("shopify-section-template--16199537360983__rich_text_9xUhez").style.display = "block";
  $(".readlessAmarok").show();
  $(".readmore").hide();
}

function readNavarra() {
 document.getElementById("shopify-section-template--16199542833239__text_and_image_wbXKLd").style.display = "block";
 document.getElementById("shopify-section-template--16199542833239__rich_text_HVWjF8").style.display = "block";
 document.getElementById("shopify-section-template--16199542833239__text_with_icons_QWV6TH").style.display = "block";
 document.getElementById("shopify-section-template--16199542833239__advanced_content_C4nNi9").style.display = "block";
 document.getElementById("shopify-section-template--16199542833239__rich_text_hpEBEY").style.display = "block";
 document.getElementById("shopify-section-template--16199542833239__rich_text_9xUhez").style.display = "block";
  $(".readlessNavarra").show();
  $(".readmore").hide();
}

function readIsuzu() {
 document.getElementById("shopify-section-template--15971782262871__text_and_image_6Gr6nY").style.display = "block";
 document.getElementById("shopify-section-template--15971782262871__rich_text_67aeBc").style.display = "block";
 document.getElementById("shopify-section-template--15971782262871__text_with_icons_bkT4Dg").style.display = "block";
 document.getElementById("shopify-section-template--15971782262871__advanced_content_tzqiJx").style.display = "block";
 document.getElementById("shopify-section-template--15971782262871__rich_text_dLtQHH").style.display = "block";
 document.getElementById("shopify-section-template--15971782262871__rich_text_nH3GCy").style.display = "block";
  $(".readlessIsuzu").show();
  $(".readmore").hide();
}

function readTriton() {
 document.getElementById("shopify-section-template--15974812876887__text_and_image_mpX7Tn").style.display = "block";
 document.getElementById("shopify-section-template--15974812876887__rich_text_kiL7be").style.display = "block";
 document.getElementById("shopify-section-template--15974812876887__text_with_icons_UxcDT6").style.display = "block";
 document.getElementById("shopify-section-template--15974812876887__advanced_content_LmPAm4").style.display = "block";
 document.getElementById("shopify-section-template--15974812876887__rich_text_YrEFnw").style.display = "block";
 document.getElementById("shopify-section-template--15974812876887__rich_text_kx4hg9").style.display = "block";
$(".readlessTriton").show();
$(".readmore").hide();
}

function readSuzuki() {
 document.getElementById("shopify-section-template--15974980616279__text_and_image_mpX7Tn").style.display = "block";
 document.getElementById("shopify-section-template--15974980616279__rich_text_kiL7be").style.display = "block";
 document.getElementById("shopify-section-template--15974980616279__text_with_icons_UxcDT6").style.display = "block";
 document.getElementById("shopify-section-template--15974980616279__advanced_content_LmPAm4").style.display = "block";
 document.getElementById("shopify-section-template--15974980616279__rich_text_YrEFnw").style.display = "block";
 document.getElementById("shopify-section-template--15974980616279__rich_text_kx4hg9").style.display = "block";
$(".readless").show();
$(".readmore").hide();
}

function readToyota() {

 document.getElementById("shopify-section-template--15975015022679__text_and_image_mpX7Tn").style.display = "block";
 document.getElementById("shopify-section-template--15975015022679__rich_text_kiL7be").style.display = "block";
 document.getElementById("shopify-section-template--15975015022679__text_with_icons_UxcDT6").style.display = "block";
 document.getElementById("shopify-section-template--15975015022679__advanced_content_LmPAm4").style.display = "block";
 document.getElementById("shopify-section-template--15975015022679__rich_text_YrEFnw").style.display = "block";
 document.getElementById("shopify-section-template--15975015022679__rich_text_kx4hg9").style.display = "block";
    $(".readlessToyota").show();
  $(".readmore").hide();
}

function readmorePrado() {
document.getElementById("shopify-section-template--16057517080663__text_and_image_wbXKLd").style.display = "block";
 document.getElementById("shopify-section-template--16057517080663__rich_text_HVWjF8").style.display = "block";
 document.getElementById("shopify-section-template--16057517080663__advanced_content_C4nNi9").style.display = "block";
 document.getElementById("shopify-section-template--16057517080663__rich_text_hpEBEY").style.display = "block";
 document.getElementById("shopify-section-template--16057517080663__rich_text_9xUhez").style.display = "block";
 document.getElementById("shopify-section-template--16057517080663__text_with_icons_QWV6TH").style.display = "block";
 $(".readmorePrado").hide(); 
 $(".readlessPrado").show();
  
}


function readmoreLC() {
document.getElementById("shopify-section-template--16057558827095__text_and_image_wbXKLd").style.display = "block";
 document.getElementById("shopify-section-template--16057558827095__rich_text_HVWjF8").style.display = "block";
 document.getElementById("shopify-section-template--16057558827095__advanced_content_C4nNi9").style.display = "block";
 document.getElementById("shopify-section-template--16057558827095__rich_text_hpEBEY").style.display = "block";
 document.getElementById("shopify-section-template--16057558827095__rich_text_9xUhez").style.display = "block";
 document.getElementById("shopify-section-template--16057558827095__text_with_icons_QWV6TH").style.display = "block";
 $(".readmoreLC").hide(); 
 $(".readlessLC").show();
  
}

function readmoreMux() {
document.getElementById("shopify-section-template--16057591332951__text_and_image_wbXKLd").style.display = "block";
 document.getElementById("shopify-section-template--16057591332951__rich_text_HVWjF8").style.display = "block";
 document.getElementById("shopify-section-template--16057591332951__advanced_content_C4nNi9").style.display = "block";
 document.getElementById("shopify-section-template--16057591332951__rich_text_hpEBEY").style.display = "block";
 document.getElementById("shopify-section-template--16057591332951__rich_text_9xUhez").style.display = "block";
 document.getElementById("shopify-section-template--16057591332951__text_with_icons_QWV6TH").style.display = "block";
 $(".readmoreMux").hide(); 
 $(".readlessMux").show();
  
}
    

function readlessToyota() {
 document.getElementById("shopify-section-template--15975015022679__text_and_image_mpX7Tn").style.display = "none";
 document.getElementById("shopify-section-template--15975015022679__rich_text_kiL7be").style.display = "none";
 document.getElementById("shopify-section-template--15975015022679__text_with_icons_UxcDT6").style.display = "none";
 document.getElementById("shopify-section-template--15975015022679__advanced_content_LmPAm4").style.display = "none";
 document.getElementById("shopify-section-template--15975015022679__rich_text_YrEFnw").style.display = "none";
 document.getElementById("shopify-section-template--15975015022679__rich_text_kx4hg9").style.display = "none";

 $(".readmore").show(); 
 $(".readlessToyota").hide();
  
}

function readlessIsuzu() {
 document.getElementById("shopify-section-template--15971782262871__text_and_image_6Gr6nY").style.display = "none";
 document.getElementById("shopify-section-template--15971782262871__rich_text_67aeBc").style.display = "none";
 document.getElementById("shopify-section-template--15971782262871__text_with_icons_bkT4Dg").style.display = "none";
 document.getElementById("shopify-section-template--15971782262871__advanced_content_tzqiJx").style.display = "none";
 document.getElementById("shopify-section-template--15971782262871__rich_text_dLtQHH").style.display = "none";
 document.getElementById("shopify-section-template--15971782262871__rich_text_nH3GCy").style.display = "none";

 $(".readmore").show(); 
 $(".readlessIsuzu").hide();
  
}

function readlessFord() {
 document.getElementById("shopify-section-template--15907375317079__text_and_image_wbXKLd").style.display = "none";
 document.getElementById("shopify-section-template--15907375317079__rich_text_HVWjF8").style.display = "none";
 document.getElementById("shopify-section-template--15907375317079__text_with_icons_QWV6TH").style.display = "none";
 document.getElementById("shopify-section-template--15907375317079__advanced_content_C4nNi9").style.display = "none";
 document.getElementById("shopify-section-template--15907375317079__rich_text_hpEBEY").style.display = "none";
 document.getElementById("shopify-section-template--15907375317079__rich_text_9xUhez").style.display = "none";
 $(".readmore").show(); 
 $(".readlessFord").hide();
  
}

function readlessFordeverest() {
 document.getElementById("shopify-section-template--16199477559383__text_and_image_wbXKLd").style.display = "none";
 document.getElementById("shopify-section-template--16199477559383__rich_text_HVWjF8").style.display = "none";
 document.getElementById("shopify-section-template--16199477559383__text_with_icons_QWV6TH").style.display = "none";
 document.getElementById("shopify-section-template--16199477559383__advanced_content_C4nNi9").style.display = "none";
 document.getElementById("shopify-section-template--16199477559383__rich_text_hpEBEY").style.display = "none";
 document.getElementById("shopify-section-template--16199477559383__rich_text_9xUhez").style.display = "none";
 $(".readmore").show(); 
 $(".readlessFordeverest").hide();
  
}

function readlessAmarok() {
 document.getElementById("shopify-section-template--16199537360983__text_and_image_wbXKLd").style.display = "none";
 document.getElementById("shopify-section-template--16199537360983__rich_text_HVWjF8").style.display = "none";
 document.getElementById("shopify-section-template--16199537360983__text_with_icons_QWV6TH").style.display = "none";
 document.getElementById("shopify-section-template--16199537360983__advanced_content_C4nNi9").style.display = "none";
 document.getElementById("shopify-section-template--16199537360983__rich_text_hpEBEY").style.display = "none";
 document.getElementById("shopify-section-template--16199537360983__rich_text_9xUhez").style.display = "none";
 $(".readmore").show(); 
 $(".readlessAmarok").hide();
  
}

function readlessNavarra() {
 document.getElementById("shopify-section-template--16199542833239__text_and_image_wbXKLd").style.display = "none";
 document.getElementById("shopify-section-template--16199542833239__rich_text_HVWjF8").style.display = "none";
 document.getElementById("shopify-section-template--16199542833239__text_with_icons_QWV6TH").style.display = "none";
 document.getElementById("shopify-section-template--16199542833239__advanced_content_C4nNi9").style.display = "none";
 document.getElementById("shopify-section-template--16199542833239__rich_text_hpEBEY").style.display = "none";
 document.getElementById("shopify-section-template--16199542833239__rich_text_9xUhez").style.display = "none";
 $(".readmore").show(); 
 $(".readlessNavarra").hide();
  
}

function readlessTriton() {
document.getElementById("shopify-section-template--15974812876887__text_and_image_mpX7Tn").style.display = "none";
 document.getElementById("shopify-section-template--15974812876887__rich_text_kiL7be").style.display = "none";
 document.getElementById("shopify-section-template--15974812876887__text_with_icons_UxcDT6").style.display = "none";
 document.getElementById("shopify-section-template--15974812876887__advanced_content_LmPAm4").style.display = "none";
 document.getElementById("shopify-section-template--15974812876887__rich_text_YrEFnw").style.display = "none";
 document.getElementById("shopify-section-template--15974812876887__rich_text_kx4hg9").style.display = "none";
 $(".readmore").show(); 
 $(".readlessTriton").hide();
  
}

    
function readlessHilux() {
document.getElementById("shopify-section-template--15915107254359__text_and_image_wbXKLd").style.display = "none";
 document.getElementById("shopify-section-template--15915107254359__rich_text_HVWjF8").style.display = "none";
 document.getElementById("shopify-section-template--15915107254359__advanced_content_C4nNi9").style.display = "none";
 document.getElementById("shopify-section-template--15915107254359__rich_text_hpEBEY").style.display = "none";
 document.getElementById("shopify-section-template--15915107254359__rich_text_9xUhez").style.display = "none";
 document.getElementById("shopify-section-template--15915107254359__text_with_icons_QWV6TH").style.display = "none";
 $(".readmore").show(); 
 $(".readless").hide();
  
}


function readlessPrado() {
document.getElementById("shopify-section-template--16057517080663__text_and_image_wbXKLd").style.display = "none";
 document.getElementById("shopify-section-template--16057517080663__rich_text_HVWjF8").style.display = "none";
 document.getElementById("shopify-section-template--16057517080663__advanced_content_C4nNi9").style.display = "none";
 document.getElementById("shopify-section-template--16057517080663__rich_text_hpEBEY").style.display = "none";
 document.getElementById("shopify-section-template--16057517080663__rich_text_9xUhez").style.display = "none";
 document.getElementById("shopify-section-template--16057517080663__text_with_icons_QWV6TH").style.display = "none";
 $(".readmorePrado").show(); 
 $(".readlessPrado").hide();
  
}

function readlessLC() {
document.getElementById("shopify-section-template--16057558827095__text_and_image_wbXKLd").style.display = "none";
 document.getElementById("shopify-section-template--16057558827095__rich_text_HVWjF8").style.display = "none";
 document.getElementById("shopify-section-template--16057558827095__advanced_content_C4nNi9").style.display = "none";
 document.getElementById("shopify-section-template--16057558827095__rich_text_hpEBEY").style.display = "none";
 document.getElementById("shopify-section-template--16057558827095__rich_text_9xUhez").style.display = "none";
 document.getElementById("shopify-section-template--16057558827095__text_with_icons_QWV6TH").style.display = "none";
 $(".readmoreLC").show(); 
 $(".readlessLC").hide();
  
}


function readlessMux() {
 document.getElementById("shopify-section-template--16057591332951__text_and_image_wbXKLd").style.display = "none";
 document.getElementById("shopify-section-template--16057591332951__rich_text_HVWjF8").style.display = "none";
 document.getElementById("shopify-section-template--16057591332951__advanced_content_C4nNi9").style.display = "none";
 document.getElementById("shopify-section-template--16057591332951__rich_text_hpEBEY").style.display = "none";
 document.getElementById("shopify-section-template--16057591332951__rich_text_9xUhez").style.display = "none";
 document.getElementById("shopify-section-template--16057591332951__text_with_icons_QWV6TH").style.display = "none";
 $(".readmoreMux").show(); 
 $(".readlessMux").hide();
  
}






// $('#purpose').on('change', function () {
//     $("#business").css('display', (this.value == '1') ? 'block' : 'none');
// });


  
